import { render, staticRenderFns } from "./PersonOrgDetailsUserInfoPer.vue?vue&type=template&id=45c2d8be&"
import script from "./PersonOrgDetailsUserInfoPer.vue?vue&type=script&lang=js&"
export * from "./PersonOrgDetailsUserInfoPer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports